/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import axios from 'axios'

export function refreshFn (initialToken) {
  let token = initialToken
  let promise = null

  return (done) => {
    if (promise === null) {
      promise = axios
        .post('/api/v1/jwts/refresh', { jwt: token })
        .then((resp) => {
          promise = null
          token = resp.data.token
          return token
        })
    }

    if (typeof done === 'function') {
      promise.then(done)
    }

    return promise
  }
}
